import AlertHandler from "~/components/alertHandler/AlertHandler";
import styles from "./CopilotMessage.module.less";
import ConversationDetail from "./components/conversationDetail/ConversationDetail";
import ConversationList from "./components/conversationList/ConversationList";
import SocketConversationSelector from "./components/socketConversationSelector/SocketConversationSelector";

function CopilotMessage() {
  return (
    <>
      <SocketConversationSelector />
      <AlertHandler />
      <div className={styles.CopilotMessage}>
        <ConversationList />
        <ConversationDetail />
      </div>
    </>
  );
}

export default CopilotMessage;
